import { render, staticRenderFns } from "./CardResult.vue?vue&type=template&id=594c0a4a&scoped=true&lang=pug"
import script from "./CardResult.vue?vue&type=script&lang=js"
export * from "./CardResult.vue?vue&type=script&lang=js"
import style0 from "./CardResult.vue?vue&type=style&index=0&id=594c0a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c0a4a",
  null
  
)

export default component.exports